var analyticsTracker = function (analytics, localAnalyticsId, event) {
    if (analytics) {
        var id = analytics.id, description = analytics.description, callback = analytics.callback;
        if (analytics.localAnalyticsId) {
            // eslint-disable-next-line no-param-reassign
            localAnalyticsId = analytics.localAnalyticsId;
        }
        if (id && typeof callback === 'function') {
            callback(typeof localAnalyticsId === 'string' && localAnalyticsId !== '' ? "".concat(id, ".").concat(localAnalyticsId) : id, description || '', event);
        }
    }
};

export { analyticsTracker };
